export const endpoints = {
  jobs: '/jobs',
  job: '/jobs/{id}',
  jobSource: '/jobs/{id}/source',
  jobSourceRetry: '/jobs/{id}/source/retry',
  jobSourcingAllowance: '/agent/jobs/{jobId}/sourcing-allowance',
  submissionDecisionMode: '/jobs/{id}/submission-decision-mode',
  jobAutomation: '/jobs/{id}/automation',
  jobState: '/jobs/{id}/state',
  jobInbound: '/jobs/{id}/inbound',
  uploadCandidates: '/jobs/{jobId}/manual-upload',
  jobNotes: '/jobs/{id}/notes',
  jobNote: '/jobs/{jobId}/notes/{id}',
} as const;
